export default {"src":"/_next/static/media/premiere-rencontre.5f36baaa.svg","height":32,"width":32,"blurWidth":0,"blurHeight":0};